"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedTransition = sharedTransition;

var _styledComponents = require("styled-components");

function sharedTransition(properties) {
  return (0, _styledComponents.css)(["transition:0.3s ease;transition-property:", ";"], properties);
}